document.addEventListener('DOMContentLoaded', async function () {

  async function getJudgemeStoreReviews() {
    try {
      const response = await fetch('https://cdn.judge.me/reviews/reviews_for_carousel?reviews_selection=store_reviews&carousel_type=cards&star_rating=5_star&max_reviews=30&url=https%3A%2F%2Fwww.morfurniture.com&shop_domain=mor-furniture.myshopify.com&platform=shopify&primary_language=en');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      return data.reviews || [];
    } catch (error) {
      console.error('Failed to fetch reviews:', error);
      return [];
    }
  }

  function setupSeeMore() {
    document.querySelector('.store-comment .store-comment-section').addEventListener('click', function (e) {
      if (!e.target.closest('.comment-content')) return
      const ellipsis = e.target.closest('.comment-content').querySelector('.see-more-ellipsis');
      if (e.target.classList.contains('see-more-action')) {
        const moreContent = e.target.closest('.comment-content').querySelector('.more-content');
        const seeLessAction = e.target.closest('.comment-content').querySelector('.see-less-action');
        if (moreContent) moreContent.style.display = 'inline';
        e.target.style.display = 'none';
        if (seeLessAction) seeLessAction.style.display = 'inline';
        if (ellipsis) ellipsis.style.display = 'none';
      } else if (e.target.classList.contains('see-less-action')) {
        const moreContent = e.target.closest('.comment-content').querySelector('.more-content');
        const seeMoreAction = e.target.closest('.comment-content').querySelector('.see-more-action');
        if (moreContent) moreContent.style.display = 'none';
        e.target.style.display = 'none';
        if (seeMoreAction) seeMoreAction.style.display = 'inline';
        if (ellipsis) ellipsis.style.display = 'inline';
      }
    });
  }

  function renderReviews(reviews) {
    const reviewItemTemplate = document.getElementById('store-comment-template');
    const container = document.querySelector('.store-comment .store-comment-section .swiper-wrapper');
    if (!reviewItemTemplate || !container) return;
    const swiperWrapper = document.querySelector('.store-comment-swiper');

    reviews.forEach(review => {
      if (!review.body || review.body === 'null') return; // Skip reviews without content
      const clone = reviewItemTemplate.content.cloneNode(true);
      const avatarEl = clone.querySelector('[data-comment-avatar]');
      const nameEl = clone.querySelector('.comment-user-name');
      const timeEl = clone.querySelector('.comment-time');
      const ratingEl = clone.querySelector('.comment-rating');
      const contentEl = clone.querySelector('.comment-content');

      if (avatarEl) {
        avatarEl.textContent = review.reviewer_name ? review.reviewer_name.charAt(0).toUpperCase() : '';
      }
      if (nameEl) nameEl.textContent = review.reviewer_name || 'Anonymous';
      if (timeEl) timeEl.textContent = review.created_at ? new Date(review.created_at).toLocaleDateString() : '';
      if (ratingEl) {
        const stars = ratingEl.querySelectorAll('.star-icon');
        stars.forEach((star, index) => {
          if (index < review.rating) {
            star.classList.add('filled');
          } else {
            star.classList.remove('filled');
          }
        });
      }
      if (contentEl) contentEl.innerHTML = `<p>${review.body.length > 300 
        ? review.body.slice(0, 300) + `<span class="more-content">${review.body.slice(300)}</span>` + '<span class="see-more-ellipsis">...</span><span class="see-more-action">See more</span><span class="see-less-action">See less</span>' 
        : review.body || ''}</p>`;

      container.appendChild(clone);
    });

    if (swiperWrapper && swiperWrapper.initSwiper) {
      swiperWrapper.initSwiper();
    } else {
      setTimeout(() => {
        if (swiperWrapper && swiperWrapper.initSwiper) {
          swiperWrapper.initSwiper();
        }
      }, 1000);
    }
    setupSeeMore()
    // swiperWrapper.initSwiper()
  }

  const reviews = await getJudgemeStoreReviews();

  renderReviews(reviews);
});
